import React from 'react';
import { Search } from 'lucide-react';
import { shortcutLabel, useCommandPalette } from './CommandPalette';

/** The search box at the top of the sidebar (on the nav band's colours) (and the search button on a phone): opens the ⌘K palette. Collapsed or
 *  compact, just the icon (named for screen readers); `onSurface` for the phone's light top bar. */
const SearchTrigger: React.FC<{ compact?: boolean; className?: string; onSurface?: boolean }> = (
  { compact = false, className = '', onSurface = false },
) => {
  const { open } = useCommandPalette();
  if (compact) {
    return (
      <button type="button" onClick={open} aria-label={`Search (${shortcutLabel()})`} title={`Search (${shortcutLabel()})`}
              className={`rounded-mp-sm p-mp-2 ${onSurface ? 'text-mp-text-muted hover:bg-mp-surface-2 hover:text-mp-text' : 'text-mp-nav-text hover:bg-mp-nav-active-bg hover:text-mp-nav-active-text'} focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-mp-accent ${className}`}>
        <Search className="h-5 w-5" />
      </button>
    );
  }
  return (
    <button type="button" onClick={open} aria-label={`Search (${shortcutLabel()})`} data-testid="search-trigger"
            className={`flex w-full items-center gap-mp-2 rounded-mp-sm border border-mp-nav-border bg-transparent px-mp-2 py-mp-1 text-left text-mp-base text-mp-nav-text hover:bg-mp-nav-active-bg hover:text-mp-nav-active-text focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-mp-accent ${className}`}>
      <Search className="h-4 w-4 shrink-0" aria-hidden />
      <span className="flex-1 truncate">Search…</span>
      <kbd className="rounded-mp-sm border border-mp-nav-border px-mp-1 text-mp-sm" aria-hidden>{shortcutLabel()}</kbd>
    </button>
  );
};

export default SearchTrigger;
